import { BaseTable, Loading, TableHeader } from "components";
import { useListDataPost } from "../../utils";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";
import { DELIVERED } from "pages/Sales/Register/utils/vars";
import { PurchaseType } from "pages/Card/Transaction/CreateNewVendor/types";

export function Purchase(props: {
    dateFrom: string
    dateTo: string
    approval?: string
    delevery?: string
    vendorId: number
}) {

    const {data, isLoading} = useListDataPost<PurchaseType>("purchase",{
        DateFrom: props.dateFrom,
        DateEnd: props.dateTo,
        Approval: props.approval,
        Delivery: props.delevery,
        VendorID: props.vendorId
    })

    const totalPurchase = data.reduce((total, item) => total + item.total, 0)
    const totalPayment = data.reduce((total, item) => total + item.total_payment, 0)

    return (
        <div>
            <div className="overflow-x-auto mt-12 max-h-[700px]">
                <BaseTable className="border-collapse">
                    <TableHeader>
                        <tr className="">
                            <th>NO</th>
                            <th>PO ID</th>
                            <th>DATE</th>
                            <th>APPROVAL</th>
                            <th>DELEVERED</th>
                            <th>QTY ORDER</th>
                            <th>QTY DELIVERED</th>
                            <th>QTY BACK ORDER</th>
                            <th>TOTAL PURCHASE</th>
                            <th>TOTAL PAYMENT</th>
                            <th>BALANCE OWING</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {isLoading || !data.length ? (
                            <tr>
                                <td colSpan={11}>
                                    <div className="w-full flex justify-center items-center">
                                        <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index: number) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.trx_code}</td>
                                    <td>{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                                    <td>{APPROVAL[item.approval_status]}</td>
                                    <td>{DELIVERED[item.delivery_status]}</td>
                                    <td className="text-center">{item.qty_order ?  convertNumber(item.qty_order).intoNormalAmount : "0"}</td>
                                    <td className="text-center">{item.qty_delivered ? convertNumber(item.qty_delivered).intoNormalAmount : "0"}</td>
                                    <td className="text-center">{item.qty_back_order ? convertNumber(item.qty_back_order).intoNormalAmount : "0"}</td>
                                    <td className="text-right">{item.total ? convertNumber(item.total).intoCurrency : "0"}</td>
                                    <td className="text-right">{item.total_payment ? convertNumber(item.total_payment).intoCurrency : "0"}</td>
                                    <td className="text-right">{item.balance_owing ? convertNumber(item.balance_owing).intoCurrency : "0"}</td>
                                </tr>
                            )
                        )              
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="mt-2 flex justify-end font-bold">
                <div className="flex flex-col gap-2">
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Purchase</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalPurchase ? convertNumber(totalPurchase).intoCurrency : "0"}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Payment</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalPayment ? convertNumber(totalPayment).intoCurrency : "0"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}